import axios from "axios";
import { getAxiosConfig } from "./axiosConfig";

// Obtener tipos de documentos
export const getTiposDocumento = async () => {
  const config = getAxiosConfig("");
  const response = await axios.get(`Pacientes/DocumentoTipoTraer`, config);
  const tiposDocs = response.data.length !== 0 ? response.data : null;
  return tiposDocs?.map((tipoDoc: any) => ({ ...tipoDoc, text: tipoDoc.nombre })) || [];
// Removed extra closing brace
};

// Obtener mutuales
export const getMutuales = async () => {
  const config = getAxiosConfig("");
  const response = await axios.get(`Mutuales`, config);
  const mutuales = response.data.length !== 0 ? response.data : null;
  return mutuales?.map((mutual: any) => ({ ...mutual, text: mutual.nombre })) || [];
// Removed extra closing brace
};

// Registrar paciente (nuevo formato)
export const registrarPaciente = async (paciente: any, tiposDoc: any[], mutuales: any[], token: string) => {
  const config = getAxiosConfig(token);
  const body = {
    hc: paciente.nroDocumento,
    documentoNro: paciente.nroDocumento,
    documentoTipo: paciente.tipoDoc,
    documentoTipoNombre: tiposDoc.find((t: any) => t.codigo === paciente.tipoDoc)?.text || "",
    nombre: paciente.nombre,
    apellido: paciente.apellido,
    mutual: paciente.mutual,
    mutualNombre: mutuales.find((m: any) => m.codigo === paciente.mutual)?.text || "",
    celular: paciente.telefono,
    email: paciente.correo,
    mutualAfiliado: paciente.mutual !== 1 ? paciente.mutualAfiliado : "-",
    nacimiento: paciente.fechaNac,
    password: paciente.nroDocumento,
  };
  return await axios.post(`pacientes`, body, config);
};

// Actualizar paciente
export const actualizarPaciente = async (data: any, token: string) => {
  const config = getAxiosConfig(token);
  const response = await axios.put(`Pacientes/PutMe`, data, config);
  return response.data;
};

// Buscar paciente por documento
export const getPaciente = async (documentoNro: string, token: string) => {
  const config = getAxiosConfig(token);
  const response = await axios.get(`Pacientes?documento=${documentoNro}`, config);
  return response.data[0];
// Removed extra closing brace
};